
import React from "react";
import oruclicksLogo from "../../../Assets/images/oruclicks-logo.svg";

// OruClick logo component (SVG asset)
const CLogo = ({
  size = "45px",
  textSize = "24px",
  showText = true,
  iconOnly = false,
  isDarkTheme = false,
  productName = "Engage",
  onClick,
  className,
  style
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedTextSize = typeof textSize === "number" ? `${textSize}px` : textSize;
  const textSizeValue = parseFloat(resolvedTextSize) || 24;
  const textSizeUnit = resolvedTextSize.replace(/[\d.]/g, "") || "px";

  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <img
        src={oruclicksLogo}
        alt="OruClick Logo"
        width={resolvedSize}
        height={resolvedSize}
        style={{
          display: "block",
          filter: isDarkTheme ? "brightness(1.15)" : "none"
        }}
      />
      {!iconOnly && showText && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontFamily: "Manrope, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            textRendering: "optimizeLegibility"
          }}
        >
          <span
            style={{
              fontSize: `${textSizeValue * 0.46}${textSizeUnit}`,
              fontWeight: 500,
              lineHeight: 1.15,
              letterSpacing: "0.3px",
              color: isDarkTheme ? "rgba(255,255,255,0.65)" : "#8A93A6"
            }}
          >
            OruClick
          </span>
          <span
            style={{
              fontSize: `${textSizeValue * 0.9}${textSizeUnit}`,
              fontWeight: 800,
              lineHeight: 1.05,
              letterSpacing: "0.2px",
              color: isDarkTheme ? "#FFFFFF" : "#0F172A"
            }}
          >
            {productName}
          </span>
        </div>
      )}
    </div>
  );
};

export default CLogo;
